export const GET_USER = 'GET_USER'

export const getUser = (user) => {
  return (dispatch) => {
    dispatch({ type: GET_USER, user })
  }
}
